<template>
  <div class="contact-form footer-wrapper" >

    <div id="contact-footer"></div>

    <div class="footer-padding">

      <div class="contact-form-inputs" >
        <h1 class="heading">{{ WhitepaperContent.heading }}</h1>
        <img class="whitepaper-image" :src="getImgUrl(WhitepaperContent.img)" v-if="WhitepaperContent.img">
        <h3 class="sub-heading" v-html="WhitepaperContent.subheading" v-show="!formIsSubmitted"></h3>


        <div v-show="!formIsSubmitted">
          <span class="input-holder">
            <input v-model="name"  type="text" name="name" placeholder="Name" class="input-element" required>
          </span>

          <span class="input-holder">
            <input v-model="emailAddress" id="contact-form-email-address" type="email" name="email" placeholder="Email address" class="input-element" required>
          </span>

          <span class="input-holder">
            <input v-model="companyName" type="text" name="company" placeholder="Company name" class="input-element" required>
          </span>

          <span class="input-holder">
            <input v-model="website" type="text" name="website" placeholder="Company website" class="input-element" required>
          </span>

          <div class="contact-form-error" v-html="formError" v-show="formError"></div>

          <button class="form-button" type="button" name="button" v-on:click="userClickedSubmit" v-if="!submitInProgress">{{ WhitepaperContent.buttonText }}</button>
          <button class="form-button form-button-progress" type="button" name="button" v-if="submitInProgress">submitting your info <i class="fa fa-spinner fa-spin"></i> </button>
        </div>

      </div>

      <div class="contact-form-success" v-show="formIsSubmitted">
        <div class="contact-form-success-header">
          Thanks!
        </div>
        <span>
          Click <a :href="WhitepaperContent.link" download target="_blank">here</a> to view and download the document.
        </span>
        <br><br>
        <span>
          Click <a :href="WhitepaperContent.videoLink" download target="_blank">here</a> to view the webinar video.
        </span>
      </div>

      <div class="logo-wrapper">
        <img src="../../../assets/mikmak-logo-black.png" alt="MikMak">

        <div class="logo-links">
          <a :href="getLink('#our-software')">Software</a> <span class="dot">&middot;</span>
          <a :href="getLink('careers')">Careers</a> <span class="dot">&middot;</span>
          <a :href="getLink('about')">About</a> <span class="dot">&middot;</span>
          <a :href="getLink('privacy')">Privacy policy</a>
        </div>
      </div>
    </div>

    <span class="footer-social-icons">
      <a href="https://instagram.com/MikMakTV/" target="new"><i class="fa fa-instagram" aria-hidden="true"></i></a>
      <a href="https://www.facebook.com/MikMakdotTV" target="new"><i class="fa fa-facebook" aria-hidden="true"></i></a>
      <a href="https://twitter.com/mikmaktv" target="new"><i class="fa fa-twitter" aria-hidden="true"></i></a>
      <a href="https://www.youtube.com/channel/UCGT0qpoynvsBolIES_xAr0w" target="new"><i class="fa fa-youtube-play" aria-hidden="true"></i></a>
    </span>

    <div class="inc-500">
      <a href="https://www.inc.com/profile/mikmak" target="new"><img src="../../../assets/inc-500.png" alt="Inc 500"></a>
    </div>

    <span class="footer-copyright">&copy 2015-{{currentYear}} TIPO Entertainment, Inc.</span>

  </div>
</template>

<script>

import eventDispatcher from '../../../events/dispatch'
import facebookEvent from '../../../events/facebookEvent'
import linkedInEvent from '../../../events/linkedInEvent'
import debounce from 'lodash/debounce'

export default {
  data() {
    return {
      formIsSubmitted: false,
      formError: false,
      name: '',
      emailAddress: '',
      companyName: '',
      website: '',
      submitInProgress: false
    }
  },
  mounted() {
    this.landingPageEvent()
  },
  methods: {
    landingPageEvent() {
      facebookEvent('ViewContent', {
        source: 'holiday2019'
      })
      linkedInEvent('holiday2019')
    },
    getImgUrl(name) {
      var images = require.context('../../../assets/')
      return images(`./${name}.png`)
    },
    getLink(link) {
      return `${window.location.origin}/${link}`
    },
    userClickedSubmit() {
      if (this.formIsValid) {
        let formData = this.getFormData()
        eventDispatcher('whitepaperFormSubmitted', formData)

        // TODO, do we want to submit these folks to Copper as if they filled
        // out the contact form?
        this.submitFormDataToCopper()
        this.formIsSubmitted = true

      } else {
        this.setFormError('Please complete all fields.')
      }
    },
    getFormData() {
      return {
        name: this.cleanString(this.name),
        email: this.emailAddress,
        companyName: this.cleanString(this.companyName),
        website: this.cleanString(this.website),
        whitepaperName: this.WhitepaperContent.whitepaperNameForEvents
      }
    },
    cleanString(str) {
      str = str || ''
      return str.replace(/[^a-zA-Z ]/g, "")
    },
    setFormError(msg) {
      this.formError = msg
      setTimeout(() => this.formError = false, 3200)
    },
    submitFormDataToCopper(formData) {

      if (window.fbq) {
        window.fbq('track', 'Lead', {
          source: 'Holiday 2019 Whitepaper'
        });
      }

      this.submitInProgress = true
      let message = this.WhitepaperContent.messageForForm
      let params = `name=${this.name}&emailAddress=${this.emailAddress}&companyName=${this.companyName}&message=${message}&website=${this.website}`
      let url = `https://mikmak-microservices.appspot.com/contactFormSubmission?${params}`
      // let url = `http://localhost:5001/contactFormSubmission?${params}`

      $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json'
      }).done((data) => {
        this.submitInProgress = false
        if (data.success) {
          this.formIsSubmitted = true
        } else {
          this.setFormError('There was an issue submitting your info. Please try again.')
        }
      });
    },
    fireEmailEvent() {
      let isValid = this.isEmailValid()
      if (isValid) {
        eventDispatcher('validEmailInput', {
          emailAddress: this.emailAddress
        })
      }
    },
    isEmailValid() {
      const regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g

      let isValid = regex.test(this.emailAddress)

      // Personal emails are not considered valid for firing email event
      if (isValid && this.isPersonalEmail()) isValid = false

      return isValid
    },
    isPersonalEmail() {
      const invalidPersonalEmails = [
        'gmail.com',
        'yahoo.com',
        'hotmail.com',
        'outlook.com',
        'aol.com',
        'comcast.net',
        'verizon.net',
        'live.com'
      ]

      let domain = this.emailAddress.split('@')[1]
      if (invalidPersonalEmails.includes(domain)) return true

      return false
    }
  },
  computed: {
    formIsValid() {
      return this.cleanString(this.name) && this.emailAddress && this.cleanString(this.companyName) && this.cleanString(this.website)
    },
    WhitepaperContent() {
      return this.$store.state.Whitepaper.Holiday2019
    },
    currentYear() {
      return new Date().getFullYear()
    }
  },
  watch: {
    emailAddress: debounce(function () {
    	this.fireEmailEvent()
    }, 600)
  }
}
</script>

<style scoped>

  .footer-wrapper {
    background: rgba(0, 0, 0, 0.05);
    padding: 24px;
  }

  .footer-padding {
    display: block;
    max-width: 600px;
    margin: 0 auto;
  }

  @media only screen and (max-width: 550px) {
    .footer-padding {
      width: 100%;
    }
  }

  .heading {
    font-weight: normal;
    font-family: "Work Sans", sans-serif;
    font-size: 32px;
    color: #333;
    text-align: center;
    margin: 0 auto;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .sub-heading {
    font-weight: normal;
    font-family: "Work Sans", sans-serif;
    font-size: 14px;
    color: #3e3e3e;
    text-align: center;
    margin: 8px auto;
    max-width: 80%;
  }

  @media only screen and (max-width: 550px) {
    .sub-heading {
      max-width: 100%;
    }
  }

  .logo-wrapper {
    margin-top: 100px;
    margin-bottom: 24px;
    text-align: center;
  }

  .logo-wrapper img {
    width: 100px;
    display: block;
    opacity: 0.8;
    margin: 0 auto;
  }

  .input-holder {

  }

  .input-element {
    border: none;
    border-bottom: 1px solid gray;
    width: 70%;
    margin: 24px auto;
    display: block;
    background: rgba(255, 255, 255, 0.35);
    padding: 8px;
    font-size: 18px;
    font-weight: lighter;
    outline: none;
    font-family: Work Sans,sans-serif;
  }

  @media only screen and (max-width: 550px) {
    .input-element {
      width: 90%;
    }
    .logo-wrapper {
      text-align: center;
    }
    .logo-wrapper img {
      margin: 12px auto;
    }
  }

  .form-button {
    display: block;
    width: 72%;
    margin: 24px auto;
    font-family: Work Sans,sans-serif;
    text-transform: uppercase;
    letter-spacing: 1px;
    -webkit-appearance: none;
    border: none;
    border-radius: 1px;
    background: black;
    color: white;
    font-size: 18px;
    cursor: pointer;
    padding: 12px;
    transition: ease-in-out 0.225s;
  }

  .form-button-progress {
    background: #c5c4c4;
  }

  .form-button:hover {
    background: #24af94;
  }

  .contact-form-error {
    color: #f16868;
    margin: 12px auto;
    width: 80%;
    text-align: center;
    font-size: 14px;
  }

  .contact-form-success {
    font-size: 18px;
    font-family: Work Sans, sans-serif;
    text-align: center;
    width: 50%;
    margin: 40px auto;
    background: #e4e4e4;
    padding: 12px;
  }

  @media only screen and (max-width: 550px) {
    .contact-form-success {
      width: 90%;
      margin: 12px auto;
    }
  }

  .logo-links {
    margin: 0 12px;
    display: block;
  }

  .logo-links a {
    text-decoration: none;
    font-size: 14px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #333;
  }

  @media only screen and (max-width: 550px) {
    .logo-links a {
      display: block;
      margin: 12px 2px;
    }

    .dot {
      display: none;
    }
  }

  .footer-social-icons {
    display: block;
    text-align: center;
    margin-top: 48px;
  }

  .footer-social-icons a {
    color: #333;
    margin: 0 12px;
  }

  .footer-copyright {
    display: block;
    margin-top: 24px;
    font-size: 12px;
    color: gray;
    text-align: center;
  }

  #contact-footer {
    height: 80px;
  }

  .contact-form-success-header {
    font-size: 28px;
    margin-bottom: 12px;
    color: #6f6f6f;
  }

  .whitepaper-image {
    display: block;
    width: 100%;
    margin: 12px 0;
    border: 1px solid #dedcdc;
    box-shadow: 0 2px 2px #e0e0e0;
  }

  .inc-500 img {
    height: 50px;
    display: block;
    margin: 48px auto;
  }

</style>



// WEBPACK FOOTER //
// Holiday2019.vue?6c2be88a